<template lang="pug">
  .component-user-edit
    .row.column.card.pt-2
      //pre(v-for="role in user.roles") {{role.id}}
      .row
        .column
          label Username
            input(type="text", v-model="user.username")
        .column
          label Email
            input(type="text", v-model="user.email")
        .column
          label Enabled
          input(type="checkbox", v-model="user.enabled")
      .row
        .column
          label Roles
            select(v-model="user.roles", multiple)
              option(v-for="role in roles", :value="role.id") {{role.name}}
        .column
          label Federation
          select(v-model="user.federation_id")
            option(:value="null") --
            option(v-for="federation in federations.items", :value="federation.id") {{federation.name}}
      ActionButton(:action="save") Save
</template>

<script>
  import ActionButton from '../../components/structure/ui/ActionButton'
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'

  export default {
    name: 'UserEdit',
    components: {ActionButton},
    data() {
      return {
        user: {
          id: null,
          federation_id: null,
          username: null,
          email: null,
          enabled: false,
          roles: [],
        },
        roles: [],
        federations: [],
      }
    },
    created() {
      KeplerBackofficeSdk.roles.list().all((data) => {
        this.roles = data.items
      })
      KeplerBackofficeSdk.federations.list(1, -1).all((data) => {
        this.federations = data
      })

      if (this.$route.params.id !== undefined) {
        this.user = {...this.item}
        this.user.federation_id = this.item.federation !== null ? this.item.federation.id : null

        this.user.roles = this.user.roles.map((item) => {
          return item.id
        })
      }
    },
    methods: {
      save() {
        if (this.$route.params.id !== undefined) {
          return KeplerBackofficeSdk.users.select(this.item).edit(this.user, () => {
            MaggieHelper.notification('user', 'User updated')
            this.$router.push({name: 'users'})
          })
        }

        return KeplerBackofficeSdk.users.make(this.user, () => {
          MaggieHelper.notification('user', 'User created')
          this.$router.push({name: 'users'})
        })
      }
    },
    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// UserEdit.vue?3752663e